export const UI_MENU_MODAL_ID = 'menu';
export const THEME_DARK = 'HEADER_DARK' as const;
export const THEME_DEFAULT = 'HEADER_NORMAL' as const;
export type HeaderTheme = typeof THEME_DARK | typeof THEME_DEFAULT;
